import React from "react"
import ReactDOM from "react-dom"
import MobileUsp from "./MobileUsp"

export default class MobileUspModule {
  constructor(elem) {
    this.elem = elem
    this.elem.usp = JSON.parse(elem.dataset.usp || "")
    this.init()
    return this
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(<MobileUsp usp={this.elem.usp} />, this.elem)
  }
}
